import axios from "axios";
import Localbase from "localbase";
import ENDPOINT from "../../context/EndPoint";

// Always clear the local session and land on the login page on the FIRST click,
// even if the server call is slow or fails. (Previously the redirect ran before
// localStorage was cleared, so the user stayed "logged in" and had to click twice.)
const LogoutUser = async ({ payload }) => {
  const finish = () => {
    try {
      localStorage.removeItem("user");
      localStorage.removeItem("msg");
      sessionStorage.clear();
    } catch (e) {}
    try {
      const db = new Localbase();
      db.collection("paths").doc("user").delete().catch(() => {});
      db.collection("paths").doc("profile").delete().catch(() => {});
      db.collection("paths").doc("notifications").delete().catch(() => {});
    } catch (e) {}
    // full reload to "/" -> with no user in storage the app renders the Signin page
    window.location.replace("/");
  };

  try {
    const formData = new FormData();
    formData.append("session", payload.session);
    await axios.post(`${ENDPOINT}logout.php`, formData);
  } catch (error) {
    console.error("Logout request failed (clearing locally anyway):", error);
  }

  finish();
  return true;
};

export default LogoutUser;
